// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1tG5N","unreadBadge":"styles_unreadBadge__1DPJo","modalContent":"styles_modalContent__qATTO","modal":"styles_modal__H60Zs"};